import { EnhancedPhoneticReplacement } from 'store/ReplacementsSlice';
import HeadlessReplacementManager from 'components/ScriptStudio/Editor/extensions/headlessReplacementManager';
import { serializeToXml } from 'components/ScriptStudio/Editor/extensions/CueCommandsExtension';
import { ReplacementWithRegex } from 'components/ScriptStudio/Editor/extensions/ReplacementExtension';
import { insertPauseTags } from 'components/ScriptStudio/Editor/extensions/PauseCueCommandsExtension';

function parseFormattedText(
  formattedText: string,
  { manager }: HeadlessReplacementManager
) {
  const lines = formattedText.split(/\n/);
  const html = lines.map(line => `<p>${line || ''}</p>`).join('');
  return manager.createState({
    content: insertPauseTags(html),
    stringHandler: 'html',
  });
}

/*
 * Apply a replacement diff (remove + add) to a single formattedText in one
 * parse/serialize roundtrip. Accepts a pre-deduped byText map so callers
 * iterating many sections can hoist dedup outside the loop.
 */
export default function applyReplacementDiff(
  formattedText: string,
  removedIds: Set<string>,
  addedByText: Map<string, EnhancedPhoneticReplacement>,
  instance: HeadlessReplacementManager,
  addedWithRegex?: ReplacementWithRegex[]
): string {
  if (!formattedText || (removedIds.size === 0 && addedByText.size === 0))
    return formattedText;

  const { ext } = instance;
  let state = parseFormattedText(formattedText, instance);

  const originalState = state;

  if (removedIds.size > 0) {
    state = state.apply(ext.removeReplacementMarks(state, removedIds));
  }
  if (addedByText.size > 0) {
    state = state.apply(
      ext.addReplacementMarksByText(state, addedByText, addedWithRegex)
    );
  }

  if (state.doc.eq(originalState.doc)) {
    return formattedText;
  }

  return serializeToXml(state);
}
